
import { Component, Vue } from "vue-property-decorator";
import { appName } from "@/env";
import { readLoginError, readMobile, readCalling } from "@/store/main/getters";
import { dispatchLogInSMS, dispatchRouteLogin } from "@/store/main/actions";

@Component
export default class Login extends Vue {
  // public email: string = "";
  public token = "";
  public appName = appName;

  public loading = false;


  public get loginError() {
    if(readLoginError(this.$store) == true)
      this.loading = false;
    console.log("login Error:"+readLoginError(this.$store));
    return readLoginError(this.$store);
  }

  public get calling() {
    if (this.token.length != 6) {
      return true;
    }
    return readCalling(this.$store);
  }

  public complete(otp: string) {
    this.token = otp;
    this.loading = true;
    dispatchLogInSMS(this.$store, {
      mobile: readMobile(this.$store),
      token: this.token
    });
  }
  public submit(event) {
    this.loading = true;
    event.preventDefault();
    if (this.token.length != 6) {
      return;
    }
    dispatchLogInSMS(this.$store, {
      mobile: readMobile(this.$store),
      token: this.token
    });

  }

  public async mounted() {
    if (!readMobile(this.$store)) {
      await dispatchRouteLogin(this.$store);
      this.loading = false;
    }
  }
}
